import { BsStars } from 'react-icons/bs';

const GeneratingView = () => {
	return (
		<div className="text-center py-6 sm:py-8">
			<div className="mx-auto mb-4 h-14 w-14 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center animate-pulse">
				<BsStars className="w-7 h-7" />
			</div>
			<h2 className="text-lg font-semibold text-text mb-1">KI erstellt Ihre Vertriebsstrategie …</h2>
			<p className="text-sm text-bgBase-800 max-w-sm mx-auto">
				Basierend auf der Analyse erstellt die KI jetzt Ihre Pipeline mit Stages, Outreach-Strategie und
				Playbook. Das dauert etwa 15–30 Sekunden.
			</p>
			<div className="mt-6 max-w-xs mx-auto">
				<div className="h-1.5 rounded-full bg-bgBase-400 overflow-hidden">
					<div className="h-full bg-primary-500 animate-pulse" style={{ width: '60%' }} />
				</div>
			</div>
		</div>
	);
};

export default GeneratingView;
